import { Checkbox } from 'src/components/check-box';
import { Deferred } from '@flowus/common/async';
import { Button } from '@flowus/common/components/button';
import { useOpenModal } from '@flowus/common/next-modal';
import type { FC } from 'react';
import { useCallback, useState } from 'react';
import { v4 } from 'uuid';
import { useUpdateUser } from 'src/hooks/user';
import { useAppTranslation } from '@flowus/common/i18n';

const WpsAuthId = v4();
interface Props {
  resolve: () => void;
  reject: () => void;
}
const WpsAuthDialog: FC<Props> = (props) => {
  const { resolve, reject } = props;
  const { t } = useAppTranslation();
  const [check, setCheck] = useState(false);

  return (
    <div className="pt-10 pb-5 px-7 text-t3 space-y-2.5">
      <div className="text-t1-medium">{t('components.file_preview.wps_auth.title')}</div>
      <div>{t('components.file_preview.wps_auth.allow_wps_action')}</div>
      <div className="flex items-center cursor-not-allowed">
        <Checkbox checked />
        <span>{t('components.file_preview.wps_auth.access_basic_info')}</span>
      </div>
      <div className="flex items-center animate-click" onClick={() => setCheck(!check)}>
        <Checkbox checked={check} />
        <span>{t('components.file_preview.wps_auth.read_write_files')}</span>
      </div>
      <div className="pt-2.5 space-y-2.5">
        <Button disable={!check} size="auto" colorType="active" onClick={resolve}>
          {t('common.authorize')}
        </Button>
        <Button size="auto" onClick={reject}>
          {t('common.cancel')}
        </Button>
      </div>
    </div>
  );
};

export const useOpenWpsAuthDialog = () => {
  const openModal = useOpenModal();
  const updateUser = useUpdateUser();

  return useCallback(async () => {
    const defer = new Deferred();

    openModal.modal({
      modalId: WpsAuthId,
      content: () => (
        <WpsAuthDialog
          resolve={() => {
            void updateUser({ setting: { wpsAuth: true } });
            defer.resolve();
            openModal.closeModal(WpsAuthId);
          }}
          reject={() => {
            defer.reject(new Error());
            openModal.closeModal(WpsAuthId);
          }}
        />
      ),
    });

    await defer.promise;
  }, [openModal, updateUser]);
};
